module.exports = __webpack_public_path__ + "static/media/83a619e0b15471e086d43e690dacae77.83a619e0.webp";